import Immutable from 'immutable';

import {
	createModuleState,
	createModelForState,
	webapi,
	REPORTED_EXCEPTION
} from 'ps-gui';
import {
	createSearchModel,
	getRawNsndTokenFilterProcessor,
} from '../utils';

const EMPTY_LIST = Immutable.List([]);
const EMPTY_MAP = Immutable.Map({});
const EMPTY_STATE = createModuleState('IsrcProtocol').set('__sessionless', true);



export default class IsrcProtocolModel {
	#data;

	constructor(data) {
		this.#data = data || EMPTY_MAP;
	}

	#setProperty(name, value) {
		if (Array.isArray(name)) {
			return new IsrcProtocolModel(this.#data.setIn(name, value));
		} else {
			return new IsrcProtocolModel(this.#data.set(name, value));
		}
	}

	#deleteProperty(name) {
		if (Array.isArray(name)) {
			return new IsrcProtocolModel(this.#data.deleteIn(name));
		} else {
			return new IsrcProtocolModel(this.#data.delete(name));
		}
	}

	#setInitialized() {
		return new IsrcProtocolModel(this.#data.set('initialized', true));
	}

	async checkGlobalContextChange(globalContext) {
		if (!globalContext) {
			return this;
		}
		const gcLangId = globalContext.getLanguageId();
		const langId = this.#data.get('langId');
		if (gcLangId === langId) {
			return this;
		}
		return (await this.initialize(globalContext)).#setProperty('languageTimestamp', new Date().getTime());
	}

	getLanguageTimestamp() {
		return this.#data.get('languageTimestamp') || 0;
	}


	async openDetail(isrc) {
		let res = await webapi.execute('/api/pd/ipd', {
			isrc
		});
		if (res === REPORTED_EXCEPTION) {
			return this;
		}
		return this.#setProperty('detail', Immutable.fromJS(res));
	}

	hideDetail() {
		return this.#setProperty('detail', null);
	}

	async refreshSearch(dontSavePreference) {
		/*		let fixedFilter = {
			status_group: STATUS_GROUPS.filter(key => statusGroupFilter.get(key))
		};*/

		let srch = this.getSearch(); //.setFixedFilter(fixedFilter);
		if (!srch) {
			return this;
		}
		srch = await srch.search(1);
		return this.setSearch(srch);
	}


	async initialize(globalContext) {
		console.log('initialize');
		let srch = createSearchModel('/api/pd/ip').setEntityName('isrcProtocol');
		let model = this;
		srch = srch.setProcessFilter(getRawNsndTokenFilterProcessor(['title', 'album', 'performers']));
		model = model.setSearch(srch).#setInitialized();
		model = await model.refreshSearch(true);
		return model.#setProperty('langId', globalContext.getLanguageId());
	}

	setSearch(model) {
		return new IsrcProtocolModel(this.#data.set('search', model.getState()));
	}

	getSearch() {
		return createModelForState(this.#data.get('search'));
	}

	getData() {
		return this.#data;
	}

	getState() {
		return EMPTY_STATE.set('data', this.#data);
	}
}


